import { type Writable, writable } from "svelte/store"
import type { IUser } from "$lib/interfaces/IUserMe"
import type { IBalance } from "$lib/interfaces/IBalance"
import type { ILevelResponse } from "$lib/interfaces/ILevel"
import { getCookie } from "$lib/utils/cookies"

export const leftSidebarIsOpenStore = writable(false)
export const mobileSidebarIsOpenStore = writable(false)

export const user: Writable<IUser | null> = writable(null)
export const userToken: Writable<string | null> = writable(null)
export const balances: Writable<IBalance[] | null> = writable(null)
export const showHeaderBanner: Writable<boolean> = writable(false)
export const myLevel: Writable<ILevelResponse | null> = writable(null)
export const OverlayLoaderShow: Writable<boolean> = writable(true)
export const DetectedCountry: Writable<string | null> = writable(null)


export const userReducer = (userData: IUser | null) => {
  const accessToken = getCookie("forza_token")

  if (!accessToken) {
    user.set(null)
    return
  }

  user.set(userData)
}

